import { CancelToken } from 'axios';
import axios from '../../utils/axios';
import { FileDataPayload } from '../../views/File/FileListView/types';
import { RequestsPerPage } from '../types';

const getFilesPerPage = async ({
  page, limit, searchValue, programId, year,
}: RequestsPerPage, cancelToken?: CancelToken) => {
  let url = `/api/files?page=${page}&limit=${limit}&searchValue=${searchValue}`;

  if (programId) {
    url += `&programId=${programId}`;
  }

  if (year) {
    url += `&year=${year}`;
  }

  const response = await axios.get(url, { cancelToken });
  return response.data;
};

const getFileSignedUrl = async (id: string) => {
  const response = await axios.get(`/api/files/${id}/url`);
  return response.data;
};

const postCreateFile = async (data: FileDataPayload) => {
  const formData = new FormData();

  if (data.file) {
    formData.append('file', data.file);
  }
  formData.append('json', JSON.stringify({
    programId: data.programId,
    name: data.name,
  }));
  const response = await axios.post('/api/files', formData);

  return response.data;
};

const putEditFile = async (data: FileDataPayload, id: string) => {
  const response = await axios.put(`/api/files/${id}`, data);

  return response.data;
};

const deleteFile = async (fileId: string) => {
  const response = await axios.delete(`/api/files/${fileId}`);

  return response.data;
};

const getFilesPerPageByStudentId = async ({
  page, limit, searchValue, studentId, year,
}: RequestsPerPage & { studentId: string, year?: number }, cancelToken?: CancelToken) => {
  let url = `/api/files/student/${studentId}?page=${page}&limit=${limit}&searchValue=${searchValue}`;
  if (year) {
    url += `&year=${year}`;
  }
  const response = await axios.get(url, { cancelToken });
  return response.data;
};

export {
  postCreateFile,
  putEditFile,
  deleteFile,
  getFilesPerPage,
  getFileSignedUrl,
  getFilesPerPageByStudentId,
};
